import React from "react";

const overlay = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.19)", zIndex: 1100,
  display: "flex", alignItems: "center", justifyContent: "center"
};
const modal = {
  background: "#fff", borderRadius: 10, padding: 30,
  width: "95vw", maxWidth: 600, maxHeight: "75vh",
  overflowY: "auto",
  boxShadow: "0 6px 30px #387be83a",
  position: "relative",
  fontFamily: "'Segoe UI','Roboto',Arial,sans-serif"
};

const headingStyle = { margin: "26px 0 7px 0", color: "#358", fontWeight: 700, fontSize: "1.08em" };
const TitleStyle = { margin: "5px 0 7px 0", color: "#2a3560", fontWeight: 700, fontSize: "30px" };
const label = { color: "#358", fontWeight: 700, fontSize: "1.08em" };
const value = { color: "#2a3560", fontWeight: 500 };
const ul = { paddingLeft: 16, marginBottom: 0 };

function listSection(arr) {
  if (!arr) return null;
  if (typeof arr === "string" && arr.trim().length === 0) return null;
  if (Array.isArray(arr) && arr.length === 0) return null;

  const items = Array.isArray(arr) ? arr : [arr];
  return <ul style={ul}>{items.map((s, i) =>
    typeof s === "string" && s.trim().length > 0 ?
      <li key={i} style={{ marginBottom: 6 }}>{s}</li> : null
  )}</ul>;
}

/** Utility to display a string with \\n as bullet list items */
function linesToList(val) {
  if (!val) return null;
  let text = '';

  if (Array.isArray(val)) {
    // Join array elements into a single string separated by space or newline
    text = val.join(' ');
  } else if (typeof val === 'string') {
    text = val;
  } else {
    return null;
  }

  // Replace literal \n sequences with actual newlines
  const replaced = text.replace(/\\n/g, '\n');

  // Split by newlines and trim
  const points = replaced.split('\n').map(s => s.trim()).filter(s => s.length > 0);

  if (points.length === 0) return null;

  return (
    <ul style={ul}>
      {points.map((pt, i) => <li key={i} style={{ marginBottom: 6 }}>{pt}</li>)}
    </ul>
  );
}

function renderMultilineField(field) {
  if (!field) return null;

  const isArray = Array.isArray(field);
  const text = isArray ? field.join(' ') : field;

  // Check if text contains literal \n sequences or real new lines
  if (typeof text === 'string' && (text.includes('\\n') || text.includes('\n'))) {
    // Use linesToList to split by newlines and render bullet points
    return linesToList(field);
  } else {
    // Otherwise render as plain list (array or single string)
    return listSection(field);
  }
}



const showLine = (labelText, valueText) => (
  valueText && String(valueText).trim().length > 0 ?
    <div style={{ marginBottom: 8 }}>
      <span style={label}>{labelText}: </span>
      <span style={value}>{valueText}</span>
    </div>
    : null
);

const JobDetailsModal = ({ job, onClose, onApply }) => (
  <div style={overlay} onClick={onClose}>
    <div style={modal} onClick={e => e.stopPropagation()}>
      <span style={{
        position: "absolute", top: 19, right: 19, fontSize: 19,
        color: "#93aac7", cursor: "pointer"
      }}
        onClick={onClose}
      >×</span>

      {(job.jobrole || job.jobTitle) && (
        <h2 style={TitleStyle}>{job.jobrole || job.jobTitle}</h2>
      )}
      {showLine("Job ID", job.jobid)}

      {(job.jobDescription || job.jd) && (
        <>
          {console.log("Job Description original:", job.jobDescription || job.jd)}
          <div style={headingStyle}>Job Description:</div>
          {renderMultilineField(job.jobDescription || job.jd)}
        </>
      )}

      {(job.educationalQualifications || job.qualifications) && (
        <>
          {console.log("Educational Qualifications original:", job.educationalQualifications || job.qualifications)}
          <div style={headingStyle}>Educational Qualifications:</div>
          {renderMultilineField(job.educationalQualifications || job.qualifications)}
        </>
      )}

      {(job.experienceRequired || job.experience) && (
        <>
          {console.log("Experience Required original:", job.experienceRequired || job.experience)}
          <div style={headingStyle}>Experience Required:</div>
          {renderMultilineField(job.experienceRequired || job.experience)}
        </>
      )}

      {job.desiredSkills && job.desiredSkills.length > 0 && (
        <>
          {console.log("Desired Skills original:", job.desiredSkills)}
          <div style={headingStyle}>Desired Skills:</div>
          {renderMultilineField(job.desiredSkills)}
        </>
      )}

      {job.requiredCertifications && job.requiredCertifications.length > 0 && (
        <>
          {console.log("Required Certifications original:", job.requiredCertifications)}
          <div style={headingStyle}>Required Certifications:</div>
          {renderMultilineField(job.requiredCertifications)}
        </>
      )}

      {job.goodToHave && job.goodToHave.length > 0 && (
        <>
          {console.log("Good to Have original:", job.goodToHave)}
          <div style={headingStyle}>Good to Have:</div>
          {renderMultilineField(job.goodToHave)}
        </>
      )}

      <br />
      {showLine("Employment Type", job.employmentType)}
      {showLine(
        "Work Mode",
        Array.isArray(job.workMode) ? job.workMode.join(", ") : job.workMode
      )}
      {showLine(
        "Job Location",
        Array.isArray(job.location) ? job.location.join(", ") : job.location || job.jobLocation
      )}
      {showLine("Joining Requirement", job.joiningRequirement || job.requiredBy)}
      {showLine("Salary Package", job.salaryPackage)}

      {/* Action buttons */}
      <div style={{ display: "flex", gap: 12, marginTop: 32, justifyContent: "flex-end" }}>
        <button
          type="button"
          style={{
            background: "#fff",
            border: "1.2px solid #dde6f2",
            borderRadius: 6,
            padding: "10px 20px",
            fontSize: "1rem",
            fontWeight: 500,
            color: "#233253",
            cursor: "pointer"
          }}
          onClick={onClose}
        >
          Close
        </button>
        <button
          type="button"
          style={{
            background: "#2684ff",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "10px 20px",
            fontSize: "1rem",
            fontWeight: 600,
            cursor: "pointer"
          }}
          onClick={onApply}
        >
          Apply Now
        </button>
      </div>
    </div>
  </div>
);


export default JobDetailsModal;
